<template>
  <transition name="ol-modal">
    <template v-if="value">
      <div class="ol-modal-mask">
        <div class="ol-modal-wrapper">
          <div class="ol-modal-container" :style="stylePopup">

            <div class="ol-modal-header">
              <slot name="header"></slot>

              <div v-if="localShowCloseHeaderBtn">
                <button class="ol-modal-button-close" @click.prevent="$emit('close')" title="Закрыть">X</button>
              </div>
            </div>

            <div class="ol-modal-body">
              <slot name="content"></slot>
            </div>

            <div class="ol-modal-footer">
              <slot name="footer"></slot>

              <div v-if="localShowCancelBtn">
                <button
                  :class="'ol-modal-button_' + btnColorError"
                  @click.prevent="$emit('cancel')"
                >{{localBtnTextCancel}}</button>
              </div>
              <div v-if="localShowConfirmBtn">
                <button
                  :class="'ol-modal-button_' + localBtnColorConfirm"
                  @click.prevent="$emit('ok')"
                  :disabled="localBtnConfirmDisabled"
                >{{localBtnTextConfirm}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </transition>
</template>

<script>
	export default {
		name: "Modal",
		props: {
			value: {
				type: Boolean,
				default: false
			},
			showCloseHeaderBtn: {
				type: Boolean,
				default: true
			},
			showConfirmBtn: {
				type: Boolean,
				default: true
			},
			showCancelBtn: {
				type: Boolean,
				default: true
			},
			btnConfirmDisabled: {
				type: Boolean,
				default: false
			},
			textCancel: {
				type: String,
				default: ''
			},
			text: {
				type: String,
				default: ''
			},
			stylePopup: {
				type: String,
				default: ''
			},
      btnColorConfirm: {
	      type: String,
	      default: 'none'
      },
      btnColorError: {
	      type: String,
	      default: 'none'
      }
		},
		data() {
			return {
				localBtnTextCancel: '',
				localBtnTextConfirm: '',
				localBtnConfirmDisabled: true,
				localBtnColorConfirm: 'none',
				localBtnConfirmCacheColor: this.btnColorConfirm,
				localShowConfirmBtn: false,
				localShowCancelBtn: false,
				localShowCloseHeaderBtn: true
			}
		},
    methods: {
			updateDisabled() {
				if (this.btnConfirmDisabled) {
					this.localBtnColorConfirm = 'disabled';
					this.localBtnConfirmDisabled = true;
				} else {
					this.localBtnColorConfirm = this.localBtnConfirmCacheColor;
					this.localBtnConfirmDisabled = false;
				}
      }
    },
    watch: {
	    textCancel() {
		    this.localBtnTextCancel = this.textCancel;
      },
	    text() {
		    this.localBtnTextConfirm = this.text;
      },
	    showConfirmBtn() {
		    this.localShowConfirmBtn = this.showConfirmBtn;
      },
	    showCancelBtn() {
		    this.localShowCancelBtn = this.showCancelBtn;
      },
	    showCloseHeaderBtn() {
		    this.localShowCloseHeaderBtn = this.showCloseHeaderBtn;
      },
	    btnConfirmDisabled() {
	    	this.updateDisabled();
	    }
    },
    mounted() {
	    this.localBtnTextCancel = this.textCancel;
	    this.localBtnTextConfirm = this.text;
	    this.localBtnColorConfirm = this.btnColorConfirm;
	    this.localBtnConfirmDisabled = this.btnConfirmDisabled;
	    this.localShowConfirmBtn = this.showConfirmBtn;
	    this.localShowCancelBtn = this.showCancelBtn;
	    this.localShowCloseHeaderBtn = this.showCloseHeaderBtn;

	    this.updateDisabled();
    }
	}
</script>

<style scoped lang="scss">

  $multipleLighten: 10%;

  $colorWhite: #fff;
  $colorBlack: #000;

  $backgroundBlue: #1a75bc;
  $colorBlue: #0D4E96;

  $backgroundGreen: #34A81C;
  $colorGreen: #12370a;

  $backgroundRed: #d30303;
  $colorRed: #750606;

  $backgroundSecondary: $colorBlack;
  $colorSilver: #d6d8db;
  $colorDarkSilver: #383d41;

  @mixin btn() {
    text-align: center;
    color: #1a75bc;
    border: none;
    padding: 10px;
    cursor: pointer;
    border-radius: 2px;
  }

  @mixin colorNone() {
    background: transparent;
    color: $colorBlue;

    &:hover{
     color: lighten($colorBlue, $multipleLighten);
    }
  }

  @mixin colorPrimary() {
    background: $backgroundBlue;
    color: $colorWhite;

    &:hover{
      background: lighten($backgroundBlue, $multipleLighten);
      color: lighten($colorWhite, $multipleLighten);
    }
  }

  @mixin colorSuccess() {
    background: $backgroundGreen;
    color: $colorWhite;
    border-color: $backgroundGreen;

    &:hover{
      background: lighten($backgroundGreen, $multipleLighten);
      color: lighten($colorWhite, $multipleLighten);
    }
  }

  @mixin colorError() {
    color: $colorRed;
    background-color: $backgroundRed;
    border-color: $colorRed;

    &:hover{
      background: lighten($backgroundRed, $multipleLighten);
      color: lighten($colorRed, $multipleLighten);
    }
  }

  @mixin colorSecondary() {
    color: $colorDarkSilver;
    background-color: $backgroundSecondary;
    border-color: $colorSilver;

    &:hover{
      background: lighten($backgroundSecondary, $multipleLighten);
      color: lighten($colorDarkSilver, $multipleLighten);
    }
  }

  @mixin colorDisabled() {
    color: $colorDarkSilver;
    background-color: $colorSilver;
    border-color: $colorDarkSilver;

    &:hover{
      background: lighten($colorDarkSilver, $multipleLighten);
      color: lighten($colorSilver, $multipleLighten);
    }
  }

  .ol-modal {
    &-mask {
      position: fixed;
      z-index: 9998;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, .5);
      display: table;
      transition: opacity .3s ease;
    }

    &-wrapper {
      display: table-cell;
      vertical-align: middle;
    }

    &-container {
      display: flex;
      justify-content: space-between;
      //align-items: center;
      flex-flow: column nowrap;
      max-width: 90vw;
      min-width: 10vw;
      max-height: 90vh;
      min-height: 10vh;
      margin: 0px auto;
      padding: 20px 30px;
      background-color: #fff;
      border-radius: 2px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
      transition: all .3s ease;
      font-family: Helvetica, Arial, sans-serif;
    }

    &-header {
      display: flex;
      display: -ms-flexbox;
      -ms-flex-align: start;
      align-items: start;
      -ms-flex-pack: justify;
      justify-content: space-between;
      padding: 1rem 0;
      border-bottom: 1px solid #e9ecef;
      border-top-left-radius: .3rem;
      border-top-right-radius: .3rem;
      word-break: break-word;

      h3 {
        margin-top: 0;
        color: #42b983;
      }
    }

    &-body {
      display: flex;
      position: relative;
      padding: 1rem 0;
      /*margin: 20px auto;*/
    }

    &-footer {
      display: -ms-flexbox;
      display: flex;
      -ms-flex-align: end;
      align-items: end;
      -ms-flex-pack: end;
      justify-content: space-between;
      padding: 1rem 0;
      border-top: 1px solid #e9ecef;
    }

    &-button-close {
      float: right;
      font-size: 1em;
      font-weight: 700;
      line-height: 1;
      color: #000;
      text-shadow: 0 1px 0 #fff;
      opacity: .5;
      background: transparent;
      border: 0;
      cursor: pointer;
    }

    &-button {

      &_none {
        @include btn;
        @include colorNone;
      }

      &_primary {
        @include btn;
        @include colorPrimary;
      }

      &_success {
        @include btn;
        @include colorSuccess;
      }

      &_error {
        @include btn;
        @include colorError;
      }

      &_disabled {
        @include btn;
        @include colorDisabled;
      }

      &_secondary {
        @include btn;
        @include colorSecondary;
      }
    }

    &-enter {
      opacity: 0;
    }

    &-leave-active {
      opacity: 0;
    }

    &-enter,
    &-leave-active {
      &-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/Components/Modal.vue